export const getTenant = () => {
  return 'column';
};
